import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ds-title-with-border',
  templateUrl: './title-with-border.component.html',
  styleUrls: ['./title-with-border.component.scss']
})
export class TitleWithBorderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
